module.exports = __webpack_public_path__ + "static/media/wearteklogo.1be17d9e.png";